const flex = {
    gap: { value: '{space.medium.value}' },
    justifyContent: { value: 'normal' },
    alignItems: { value: 'stretch' },
    alignContent: { value: 'normal' },
    flexWrap: { value: 'nowrap' },
};

export { flex };
